import { defineMessages } from 'react-intl';

export const textDetailsMessages = defineMessages({
    to: {
        id: 'forms.lineItem.to',
        description: 'To with colon and space',
        defaultMessage: 'To: '
    },
    from: {
        id: 'forms.lineItem.from',
        description: 'From with colon and space',
        defaultMessage: 'From: '
    },
    deliveryDate: {
        id: 'forms.lineItem.deliveryDate',
        description: 'Delivery date with colon and space',
        defaultMessage: 'Delivery Date: '
    }
});

export const listingFormMessages = defineMessages({
    emailDelivery: {
        id: 'forms.lineItem.emailDelivery',
        description: 'Message indicating that this will be delivered by email',
        defaultMessage: 'Email Delivery to {name}'
    },
    selfBuyEmailDelivery: {
        id: 'forms.lineItem.selfBuyEmailDelivery',
        description: 'Message indicating that this will be delivered by email',
        defaultMessage: 'Email Delivery to You'
    },
    viewDetailsButtonText: {
        id: 'forms.lineItem.viewDetailsButtonText',
        description: 'Text for view details button',
        defaultMessage: 'View Details'
    },
    hideDetailsButtonText: {
        id: 'forms.lineItem.hideDetailsButtonText',
        description: 'Text for hide details button',
        defaultMessage: 'Hide Details'
    },
    removeLineItemPrompt: {
        id: 'forms.lineItem.removeLineItemPrompt',
        description: 'Text of confirmation dialog for removing a line item from the cart',
        defaultMessage: 'Are you sure you want to remove this card?'
    },
    removeLineItemConfirm: {
        id: 'forms.lineItem.removeLineItemConfirm',
        description: 'Text of button for confirming removal of a line item from the cart',
        defaultMessage: 'Remove'
    },
    removeLineItemCancel: {
        id: 'forms.lineItem.removeLineItemCancel',
        description: 'Text of button for cancelling removal of a line item from the cart',
        defaultMessage: 'Cancel'
    },
    removeButtonText: {
        id: 'forms.lineItem.removeButtonText',
        description: 'Text for remove button',
        defaultMessage: 'Remove'
    },
    editButtonText: {
        id: 'forms.lineItem.editButtonText',
        description: 'Text for edit button',
        defaultMessage: 'Edit'
    },
    promoNotQualified: {
        id: 'forms.lineItem.promoNotQualified',
        description: 'Text for a non-qualifying line item',
        defaultMessage: 'Sorry, this promotion does not apply'
    },
    cardFeeText: {
        id: 'forms.lineItem.cardFeeText',
        description: 'Text to show card fee',
        defaultMessage: 'Fee/card'
    }
});

export const shippingMessages = defineMessages({
    shipTo: {
        id: 'forms.lineItem.shipTo',
        description: 'Ship to label',
        defaultMessage: '{quantity} {quantity, plural, one {Card} other {Cards}} Shipped to:'
    },
    retryFetchShippingMethodsLabel: {
            id: 'orderSummary.orderSummaryMessages.retryFetchShippingMethodsLabel',
            description: 'Text of button for retrying fetch to get shipping method',
            defaultMessage: 'TRY AGAIN'
    },
    shippingMethodsErrorLabel: {
        id: 'orderSummary.orderSummaryMessages.shippingMethodsErrorLabel',
        description: 'Label for shipping method fetch error',
        defaultMessage: 'Unable to get shipping methods.'
    }
});
